import React, { useEffect, useState } from "react";
import { errorNotify } from "../../services/toast.notification";
import { getClientComputerInformation } from '../../api/api';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import Spinner from "../../components/_common/Spinner";
import './style.css'
import { ColumnsType } from "antd/lib/table";
import './style.css'
import { UpdateClientComputerInfo } from "../../redux/reducers/ClientComputerInfoSlice";
import BackupInfoTable from "../../components/_common/Table/backupInfoTable";

export interface InputProps {
  url: any
}

const ClientComputerInformation = ({ url }: InputProps) => {

  type Column = {
    title: string,
    dataIndex: string,
    key: string,
  }

  const columns: Column[] = [
    { title: 'Computername', dataIndex: 'Computername', key: 'Computername' },
    { title: 'MyLocalIp ', dataIndex: 'MyLocalIp', key: 'MyLocalIp' },
    { title: 'CentralUserName ', dataIndex: 'CentralUserName', key: 'CentralUserName' },
    { title: 'CentralVer', dataIndex: 'CentralVer', key: 'CentralVer' },
    { title: ' JournalVer', dataIndex: 'JournalVer', key: 'JournalVer' },
    { title: 'internet', dataIndex: 'internet', key: 'internet' },
    { title: 'CheckSQLConnectionString', dataIndex: 'CheckSQLConnectionString', key: 'CheckSQLConnectionString' },
    { title: 'MySQLConnectionString', dataIndex: 'MySQLConnectionString', key: 'MySQLConnectionString' },
    { title: 'ComputerUserName', dataIndex: 'ComputerUserName', key: 'ComputerUserName' },
    { title: 'WinDowsInformation', dataIndex: 'WinDowsInformation', key: 'WinDowsInformation' },
    { title: 'RamInfo', dataIndex: 'RamInfo', key: 'RamInfo' },
    { title: 'HardSize', dataIndex: 'HardSize', key: 'HardSize' },
    { title: 'CPU', dataIndex: 'CPU', key: 'CPU' },
    { title: 'IsAdmin', dataIndex: 'IsAdmin', key: 'IsAdmin' },
    { title: 'PadvishIsInstaled', dataIndex: 'PadvishIsInstaled', key: 'PadvishIsInstaled' },
    { title: 'PadvishIsRun', dataIndex: 'PadvishIsRun', key: 'PadvishIsRun' },
    { title: 'FireWall', dataIndex: 'FireWall', key: 'FireWall' },
    { title: 'RemotDescPortIsOpen', dataIndex: 'RemotDescPortIsOpen', key: 'RemotDescPortIsOpen' },
  ];

  const myStore = useAppSelector((state) => state)
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const data = myStore.computerList.list;
  console.log(data);

  const  [currentPage, setCurrentPage] = useState(1); //new
  const  pageSize = 10; //new
  const totalPage = Math.ceil(data.length / pageSize); //new
  const startIndex = (currentPage - 1) * pageSize; // new
  const currentData = data.slice(startIndex, startIndex + pageSize); // new

  const _getClientComputerInformation = (url: string) => {
    getClientComputerInformation(url)
      .then((result: any) => {
        dispatch(UpdateClientComputerInfo({ computerList: result }))
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })


  }

  useEffect(() => {
    _getClientComputerInformation(url);
  }, [])

  return (
    <div className="tab-content-padding">
      {
        isLoading === false && (
          <>
            {myStore.computerList.list && myStore.computerList.list.length > 0 && (
              // <div className="inner-tabs_content">
              //   <BackupInfoTable isloading={false}
              //     data={myStore.computerList.list} columns={columns}
              //   />
              // </div>
                <div className="card-table m-b-0">
                  <div className="thead thead-light">
                    <div className="tr" style={{gridTemplateColumns: '125px 100px 140px 120px 115px 100px 200px 400px 173px 200px 200px 200px 200px 100px 150px 120px 200px 184px'}}>
                      {columns.map((item) => (
                          <div className="th text-center" key={item.key}>{item.title}</div>
                      ))}
                    </div>
                  </div>
                  <div className="tbody">
                    {currentData.map((log:any) => (
                        <div className="tr" style={{gridTemplateColumns: '125px 100px 140px 120px 115px 100px 200px 400px 173px 200px 200px 200px 200px 100px 150px 120px 200px 184px'}}>
                          {columns.map((item) => (
                              <div className={item.title === "MySQLConnectionString" ? "td text-center small" : "td text-center"} key={item.key}
                                   data-label={item.title} >
                                <span title={log[item.dataIndex]}>{log[item.dataIndex]}</span></div>
                          ))}
                        </div>
                    ))}
                  </div>
                  <div className="pagination">
                    <button className={'goToPage goFirst'} disabled={currentPage === 1} onClick={()=> setCurrentPage(1)}></button>
                    <button className={'goToPage goPrev'} disabled={currentPage === 1} onClick={()=> setCurrentPage((prev) => prev - 1)}></button>
                    {Array.from({length: totalPage} , (_,i) => i+1)
                        .filter((page) => {
                          if(currentPage <= 3)
                            return page <= 5;
                          if(currentPage >= totalPage - 2)
                            return page > totalPage - 5;
                          if(page >= currentPage - 2 && page <= currentPage + 2)
                            return page >= currentPage - 2 && page <= currentPage + 2;
                        })
                        .map((page) => (
                            <button type={'button'} key={page} className={page === currentPage ? "pageLink active" :"pageLink"} onClick={()=> setCurrentPage(page)}>{page}</button>
                        ))}
                    <button className={'goToPage goNext'} disabled={currentPage === totalPage} onClick={()=> setCurrentPage((prev) => prev + 1)}></button>
                    <button className={'goToPage goLast'} disabled={currentPage === totalPage} onClick={()=> setCurrentPage(totalPage)}></button>
                  </div>
                </div>
            )}
            {myStore.computerList.list && myStore.computerList.list.length == 0 && (
              <p className="empty-data">داده ای برای نمایش موجود نیست.</p>
            )

            }
          </>
        )
      }
      {
        isLoading === true && (
          <Spinner />
        )
      }
    </div>

  )
}
export default ClientComputerInformation;
